
const digest = '99d2c746dad6ebf2c3e309c002381a6ae1e7d75484e116a90b4c5474ed1ad73b';
const classes = {"wrapper":"_wrapper_4nynz_1","list":"_list_4nynz_9","scrollContainer":"_scrollContainer_4nynz_17","empty":"_empty_4nynz_22"};
const css = `._wrapper_4nynz_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  height: calc(100vh - 85px);
  max-height: 100%;
}
._wrapper_4nynz_1 ._list_4nynz_9 {
  position: relative;
  background: #ffffff;
  padding: 24px;
  border: 1px solid #eaedf3;
  overflow: hidden;
  height: 100%;
}
._wrapper_4nynz_1 ._list_4nynz_9 ._scrollContainer_4nynz_17 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_4nynz_1 ._list_4nynz_9 ._empty_4nynz_22 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  